import { FeatureFlag } from '../FeatureFlag';

/**
 * Renders LAB v2 Cost Info through the new owned grid (`TableModelViewer`, ADR 0014) instead of
 * the ag-grid `ColumnTemplateTableViewerLegacy`.
 *
 * Deliberately scoped to LAB v2. LAB v1 has a separate Cost Info component and remains on the
 * legacy grid for the remainder of its deprecation window.
 */
export const enableNewLab2CostInfoGrid = new FeatureFlag({
    key: 'enable-new-lab-2-cost-info-grid',
    defaultValue: false,
});
